<script setup lang="ts">
// AppKit 已在 plugins/appkit.ts 中初始化
import ToastNotification from '@/components/Toast.vue'
</script>

<template>
	<div>
		<router-view />
		<ToastNotification />
	</div>
</template>
 

<style>
:root {
	--primary-color: #10b981;
}

.xSheetLoading {
	position: absolute;
	z-index: 2;
	background-color: rgba(60, 60, 60, 0.5);
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	left: 0px;
	top: 0px; 
	backdrop-filter: blur(3px); 
 	border-radius: 10px;
}

.xSheetLock {
	position: fixed;
	z-index: 49;
	background-color: rgba(60, 60, 60, 0.5);
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	left: 0px;
	top: 0px;
	backdrop-filter: blur(3px);
	border-radius: 10px;

}
</style>
